export default __webpack_public_path__ + "static/media/BenchMates.cd190507.PNG";